import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-wrap gap-4"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex justify-end items-baseline" }
const _hoisted_5 = { class: "text-xl" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-gray-500 ml-1"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_9 = {
  key: 0,
  class: "expand-content"
}
const _hoisted_10 = {
  key: 1,
  class: "expand-content text-gray-500"
}
const _hoisted_11 = {
  key: 1,
  style: {"overflow-y":"auto","height":"calc(100vh - 242px)"}
}
const _hoisted_12 = { class: "flex flex-wrap gap-4 p-4" }
const _hoisted_13 = { class: "flex flex-col justify-between" }
const _hoisted_14 = { class: "flex justify-between" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "flex flex-col justify-between" }
const _hoisted_17 = { class: "flex justify-center items-baseline" }
const _hoisted_18 = { class: "text-5xl" }
const _hoisted_19 = {
  key: 0,
  class: "text-sm text-gray-500 ml-1"
}
const _hoisted_20 = { class: "flex justify-center" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  class: "h-[120px]",
  align: "center"
}
const _hoisted_24 = {
  key: 1,
  class: "w-full h-full bg-gray-100"
}
const _hoisted_25 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_26 = {
  key: 0,
  class: "expand-content"
}
const _hoisted_27 = {
  key: 1,
  class: "expand-content text-gray-500"
}
const _hoisted_28 = {
  key: 0,
  class: "expand-content"
}
const _hoisted_29 = {
  key: 1,
  class: "expand-content text-gray-500"
}
const _hoisted_30 = { class: "flex items-center" }
const _hoisted_31 = { class: "flex items-center" }
const _hoisted_32 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_33 = {
  key: 0,
  class: "text-sm text-gray-500 ml-1"
}
const _hoisted_34 = {
  key: 0,
  class: "flex w-full flex-col md:flex-row md:justify-between mt-4"
}
const _hoisted_35 = { class: "md:ml-6" }
const _hoisted_36 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_37 = { class: "hidden md:flex items-center mb-4" }
const _hoisted_38 = { class: "mr-5" }
const _hoisted_39 = { class: "md:hidden flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowUp = _resolveComponent("ArrowUp")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_DetailLevelInventoryList = _resolveComponent("DetailLevelInventoryList")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_ImgLoading = _resolveComponent("ImgLoading")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_WarnTriangleFilled = _resolveComponent("WarnTriangleFilled")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "md:hidden",
      style: _normalizeStyle({'height': _ctx.isStandalone ? 'calc(100vh - 242px)' : 'auto'})
    }, [
      (!_ctx.isStandalone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((!_ctx.isStandalone ? _ctx.tableData : _ctx.data), (item) => {
              return (_openBlock(), _createBlock(_component_el_card, {
                style: {"width":"100%","border":"2px solid #d1d5db","border-radius":"10px"},
                key: item.inventory_id
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { align: "middle" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 3 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            (!item.isExpand)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "material-symbols-outlined cursor-pointer",
                                  onClick: ($event: any) => (_ctx.handleExpandButton(item))
                                }, [
                                  _createVNode(_component_el_icon, { size: 16 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ArrowDown)
                                    ]),
                                    _: 1
                                  })
                                ], 8, _hoisted_2))
                              : (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: "material-symbols-outlined cursor-pointer",
                                  onClick: ($event: any) => (_ctx.handleCollapseButton(item))
                                }, [
                                  _createVNode(_component_el_icon, { size: 16 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ArrowUp)
                                    ]),
                                    _: 1
                                  })
                                ], 8, _hoisted_3))
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 15 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, _toDisplayString(item.department_name), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 5 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(item.quantity), 1),
                            (item.material_unit)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.material_unit), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 1 }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: "material-symbols-outlined cursor-pointer mt-1.5",
                            onClick: ($event: any) => (_ctx.handleSetConstantButton(item))
                          }, " settings ", 8, _hoisted_7)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  (item.isExpand)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (item.details && item.details.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createVNode(_component_DetailLevelInventoryList, {
                                data: item.details,
                                loading: false,
                                "is-standalone": false,
                                onEdit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit', $event))),
                                onDelete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete', $event))),
                                onAlarm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('alarm', $event))),
                                onTransferInventory: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('transferInventory', $event))),
                                onQuantityUpdate: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('quantityUpdate', $event)))
                              }, null, 8, ["data"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_10, " データを読み込み中... "))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((!_ctx.isStandalone ? _ctx.tableData : _ctx.data), (item) => {
                return (_openBlock(), _createBlock(_component_el_card, {
                  style: {"width":"100%","border":"2px solid #d1d5db","border-radius":"10px"},
                  key: item.inventory_id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", null, _toDisplayString(item.organization_name), 1),
                        _createElementVNode("span", {
                          class: "material-symbols-outlined cursor-pointer",
                          onClick: ($event: any) => (_ctx.handleSetConstantButton(item))
                        }, " settings ", 8, _hoisted_15)
                      ]),
                      _createElementVNode("div", null, _toDisplayString(item.department_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", null, _toDisplayString(item.material_name), 1),
                      _createElementVNode("div", null, _toDisplayString(item.category_name), 1)
                    ]),
                    _createVNode(_component_el_row, { align: "middle" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, {
                          span: 10,
                          justify: "center"
                        }, {
                          default: _withCtx(() => [
                            _cache[23] || (_cache[23] = _createElementVNode("div", null, "在庫合計", -1)),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(item.quantity), 1),
                              (item.material_unit)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(item.material_unit), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              (!item.isExpand)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "material-symbols-outlined cursor-pointer",
                                    onClick: ($event: any) => (_ctx.handleExpandButton(item))
                                  }, [
                                    _createVNode(_component_el_icon, { size: 16 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ArrowDown)
                                      ]),
                                      _: 1
                                    })
                                  ], 8, _hoisted_21))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: "material-symbols-outlined cursor-pointer",
                                    onClick: ($event: any) => (_ctx.handleCollapseButton(item))
                                  }, [
                                    _createVNode(_component_el_icon, { size: 16 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ArrowUp)
                                      ]),
                                      _: 1
                                    })
                                  ], 8, _hoisted_22))
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_col, { span: 14 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_23, [
                              (item.images)
                                ? (_openBlock(), _createBlock(_component_ImgLoading, {
                                    key: 0,
                                    modelValue: item.images,
                                    "onUpdate:modelValue": ($event: any) => ((item.images) = $event),
                                    class: "carousel-image"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_24))
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    (item.isExpand)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          (item.details && item.details.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createVNode(_component_DetailLevelInventoryList, {
                                  data: item.details,
                                  loading: false,
                                  "is-standalone": false,
                                  onEdit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('edit', $event))),
                                  onDelete: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('delete', $event))),
                                  onAlarm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('alarm', $event))),
                                  onTransferInventory: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('transferInventory', $event))),
                                  onQuantityUpdate: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('quantityUpdate', $event)))
                                }, null, 8, ["data"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_27, " データを読み込み中... "))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ]))
    ], 4)), [
      [_directive_loading, _ctx.loading]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["hidden md:block w-full", { 'nested-table': !_ctx.isStandalone }])
    }, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "tableRef",
        data: (!_ctx.isStandalone ? _ctx.tableData : _ctx.data),
        height: _ctx.tableHeight,
        "row-key": "inventory_id",
        "show-header": _ctx.isStandalone,
        onExpandChange: _ctx.handleExpandChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "expand",
            label: "詳細",
            width: "80",
            align: "center"
          }, {
            default: _withCtx((props) => [
              (props.row.details && props.row.details.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(_component_DetailLevelInventoryList, {
                      data: props.row.details,
                      loading: false,
                      "is-standalone": false,
                      onEdit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('edit', $event))),
                      onDelete: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('delete', $event))),
                      onAlarm: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('alarm', $event))),
                      onTransferInventory: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('transferInventory', $event))),
                      onQuantityUpdate: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('quantityUpdate', $event)))
                    }, null, 8, ["data"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, " データを読み込み中... "))
            ]),
            _: 1
          }),
          (_ctx.isStandalone)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                prop: "organization_name",
                label: "所属組織",
                width: "200"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "flex items-center cursor-pointer whitespace-nowrap",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleSort('organization_name')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('organization_name')), 1),
                    _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'organization_name' }])
                        }, _toDisplayString(_ctx.getSortIcon('organization_name')), 3)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("span", null, _toDisplayString(scope.row.organization_name), 1)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            prop: "department_name",
            label: "所属部門",
            width: "200"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", {
                class: "flex items-center cursor-pointer whitespace-nowrap",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleSort('department_name')))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('department_name')), 1),
                _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'department_name' }])
                    }, _toDisplayString(_ctx.getSortIcon('department_name')), 3)
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.indentClass)
                }, _toDisplayString(scope.row.department_name), 3)
              ])
            ]),
            _: 1
          }),
          (_ctx.isStandalone)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                prop: "category_name",
                label: "カテゴリ",
                width: "160"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "flex items-center cursor-pointer whitespace-nowrap",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleSort('category_name')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('category_name')), 1),
                    _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'category_name' }])
                        }, _toDisplayString(_ctx.getSortIcon('category_name')), 3)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isStandalone)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 2,
                prop: "material_name",
                label: "アイテム名",
                "min-width": "400"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "flex items-center cursor-pointer whitespace-nowrap",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleSort('material_name')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('material_name')), 1),
                    _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'material_name' }])
                        }, _toDisplayString(_ctx.getSortIcon('material_name')), 3)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(scope.row.material_name), 1),
                    _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                    (scope.row.jancode)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, " （" + _toDisplayString(scope.row.jancode) + "） ", 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isStandalone)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 3,
                prop: "blank"
              }))
            : _createCommentVNode("", true),
          (!_ctx.isStandalone)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 4,
                prop: "blank"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            prop: "quantity",
            label: "在庫数",
            width: "100",
            "header-align": "center",
            align: "right"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", {
                class: "flex items-center cursor-pointer whitespace-nowrap",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleSort('quantity')))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('quantity')), 1),
                _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'quantity' }])
                    }, _toDisplayString(_ctx.getSortIcon('quantity')), 3)
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.quantity), 1),
              (scope.row.material_unit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(scope.row.material_unit), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "100",
            "header-align": "center",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "info",
                style: {"background-color":"#b7b7b7"},
                text: "",
                bg: "",
                onClick: ($event: any) => (_ctx.handleSetConstantButton(scope.row))
              }, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [
                  _createElementVNode("span", null, "定数設定", -1)
                ])),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }),
          (_ctx.isStandalone)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 5,
                prop: "",
                label: "画像",
                width: "52",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.images)
                    ? (_openBlock(), _createBlock(_component_ImgLoading, {
                        key: 0,
                        "model-value": scope.row.images,
                        class: "thumbnail"
                      }, null, 8, ["model-value"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isStandalone)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 6,
                prop: "blank",
                width: "18"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data", "height", "show-header", "onExpandChange"])), [
        [_directive_loading, _ctx.loading]
      ])
    ], 2),
    (!_ctx.isStandalone && _ctx.data.length > _ctx.INVENTORY_CONSTANTS.DEPARTMENT_LEVEL.PAGE_SIZE)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            (_ctx.data.length > _ctx.INVENTORY_CONSTANTS.DEPARTMENT_LEVEL.EXCEED_RANGE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createVNode(_component_el_icon, {
                    color: "#E6A23C",
                    size: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_WarnTriangleFilled)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", null, "部門の検索結果が" + _toDisplayString(_ctx.INVENTORY_CONSTANTS.DEPARTMENT_LEVEL.EXCEED_RANGE) + "件を超えています。", 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, "部門総計 " + _toDisplayString(_ctx.data.length) + " 件", 1),
              _createVNode(_component_el_pagination, {
                "current-page": _ctx.itemCurrentPage,
                "onUpdate:currentPage": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.itemCurrentPage) = $event)),
                "page-size": _ctx.itemPageSize,
                "onUpdate:pageSize": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.itemPageSize) = $event)),
                layout: "prev, pager, next",
                total: _ctx.data.length,
                onSizeChange: _ctx.handleItemSizeChange,
                onCurrentChange: _ctx.handleItemCurrentChange
              }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_el_pagination, {
                "page-size": _ctx.itemPageSize,
                "onUpdate:pageSize": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.itemPageSize) = $event)),
                layout: "prev, pager, next",
                total: _ctx.data.length,
                onCurrentChange: _ctx.handleItemCurrentChange
              }, null, 8, ["page-size", "total", "onCurrentChange"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}